export const MY_SCORES_CONTAINER = {
  FILTERS: {
    all: '',
    live: 'live',
  },
  CURRENT_DATES_RANGE: 3,
  WEEK_DAYS: 7
};